import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getUsernameRecoverUrl } from '../../shared/utils/api-urls.utils';

@Injectable({
  providedIn: 'root',
})
export class UsernameService {
  constructor(private readonly _http: HttpClient) {}

  /**
   * Send recover username request to the API
   * @param email User's email
   * @param ssnLast4 Last 4 digits of SSN
   * @param dateOfBirth Date of birth (yyyy-MM-dd)
   * @returns Observable of the response
   */
  recoverUsername(email: string, ssnLast4: string, dateOfBirth: string): Observable<any> {
    const body = { email, ssnLast4, dateOfBirth };
    return this._http.post<any>(getUsernameRecoverUrl(), body);
  }
}
